<p-toast></p-toast>
<div class="px-6 py-4">
  <p-tabView styleClass="evaluation-tabs" (onChange)="onTabChange()">
    <p-tabPanel *ngIf="canSeeCategory" [header]="'remunerationGrid.tabs.category' | translate">
      <div data-testid="evaluation-category-tab">
        <div class="flex justify-content-between mb-4">
          <p class="text-xl font-semibold">{{ 'layout.configurations.evaluation.title' | translate }}</p>
          <p-button
            *emPermission="Permission.CONFIG_PERFORMANCE"
            class="p-button-success"
            icon="pi pi-plus"
            severity="success"
            (onClick)="includeForm()"></p-button>
        </div>
        <p-table
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 20, 50, 100]"
          paginatorPosition="bottom"
          paginatorAlignment="center"
          [value]="filters"
          styleClass="w-full p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" pSortableColumn="label" class="bg-white">
                {{ 'layout.configurations.evaluation.label' | translate }} <p-sortIcon field="label" />
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-filter>
            <tr>
              <td>{{ filter.label }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>
    <p-tabPanel *ngIf="canSeeRemuneration" [header]="'remunerationGrid.tabs.remuneration' | translate">
      <em-remuneration-grid></em-remuneration-grid>
    </p-tabPanel>

    <!--
      cache is false so each tab is rebuilt when it is shown. A category saved in
      the Categories tab has to be available immediately in the Salary Range tab.
    -->
    <p-tabPanel [cache]="false">
      <ng-template pTemplate="header">
        {{ 'layout.configurations.evaluation.tabs.salaryRanges' | translate }}
      </ng-template>
      <em-evaluation-salary-ranges />
    </p-tabPanel>
  </p-tabView>
</div>
